import { createFileRoute, redirect } from '@tanstack/react-router'
import { isSysAdmin } from '@/common/adminRouting'

export const Route = createFileRoute('/_auth/')({
  beforeLoad: ({ context }) => {
    const profile = context.user.userOrgProfile
    if (isSysAdmin(profile)) {
      throw redirect({ to: '/admin' })
    }
    const orgSlug = profile?.org.slug
    if (!orgSlug) {
      throw redirect({ to: '/login' })
    }
    throw redirect({ to: '/$orgSlug', params: { orgSlug } })
  }
})
